import React from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'i18n';
import Image from '../common/Image';

const useStyles = makeStyles()(() => ({
  image: {
    width: '174px',
    height: '41px',
    maxWidth: 196,
    maxHeight: '41px',
  },
  image1: {
    width: '126px',
    height: 'auto',
    maxHeight: 45,
  },
  image2: {
    width: '197px',
    height: 'auto',
    maxHeight: 50,
  },
  card: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 138,
    padding: '16px !important',
  },
}));

const CincinnatiSponsorsBlock = () => {
  const { classes } = useStyles();
  const [t] = useTranslation('public');

  return (
    <Grid container spacing={6} sx={{ pb: '180px' }}>
      {/* Left column */}
      <Grid item xs={12} md={6}>
        <Typography variant="h5" fontWeight={700} sx={{ pb: 4 }}>
          {t('sponsorsBlock.communityConveners')}
        </Typography>
        <Grid container spacing={2}>
          {/* Card 1 */}
          <Grid item xs={6} sm={6}>
            <Card elevation={0} sx={{ borderRadius: 4, bgcolor: '#F5F6FA' }}>
              <CardContent className={classes.card}>
                <Image
                  variant="aspectRatio"
                  objectFit="contain"
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  className={classes.image}
                  src="/static/svg/homepage/supporters/JCCA-Lapis-w-name-small.svg"
                  alt="/static/svg/homepage/supporters/JCCA-Lapis-w-name-small.svg"
                />
              </CardContent>
            </Card>
          </Grid>
          {/* Card 2 */}
          <Grid item xs={6} sm={6}>
            <Card elevation={0} sx={{ borderRadius: 4, bgcolor: '#f5f6fa' }}>
              <CardContent className={classes.card}>
                <Image
                  variant="aspectRatio"
                  objectFit="contain"
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  className={classes.image1}
                  src="/static/svg/homepage/supporters/community-cincinnati-logo-2.svg"
                  alt="/static/svg/homepage/supporters/community-cincinnati-logo-2.svg"
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
      {/* Right column */}
      <Grid item xs={12} md={6}>
        <Typography variant="h5" fontWeight={700} align="left" sx={{ pb: 4 }}>
          {t('sponsorsBlock.JLiveCincinnatiPresentedBy')}
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6} sm={6} md={6}>
            <Card elevation={0} sx={{ borderRadius: 4, bgcolor: '#F5F6FA' }}>
              <CardContent className={classes.card}>
                <Image
                  variant="aspectRatio"
                  objectFit="contain"
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  className={classes.image2}
                  src="/static/svg/homepage/supporters/JFC-logo-2.svg"
                  alt="/static/svg/homepage/supporters/JFC-logo-2.svg"
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CincinnatiSponsorsBlock;
